export function parseJSONFromScript<T>(id: string, doc: Document = document): T | null {
  const el = doc.getElementById(id)
  const isValidElement = el && el.tagName === 'SCRIPT' && el.getAttribute('type') === 'application/json'

  if (!isValidElement) return null

  try {
    return JSON.parse(el.textContent!)
  } catch (e) {
    Sentry.captureException(e)
    return null
  }
}
